"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VideoThumbnail;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _thumbnail = _interopRequireDefault(require("./thumbnail"));
var _videoLightbox = _interopRequireDefault(require("../video-lightbox"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-len */

const VideoSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "VideoSection",
  class: "pl-vhyy79d"
});

/**
 * Video Thumbnail Component
 * @module VideoThumbnail
 *
 * @param {Object} props React props
 * @param {string} props.id The component's id
 * @param {string} props._name The component's tracking name
 * @param {string} props.youTubeId Banner Image data
 * @param {string} props.ariaLabelCloseButton Eyebrow text
 * @param {Object} props.transcriptButton Heading text
 * @param {string} props.verticalMargin Vertical Spacing value
 * @returns {React.ReactElement} Video Thumbnail Component
 * @public
 */
function VideoThumbnail({
  _name,
  id,
  youTubeId,
  ariaLabelCloseButton,
  transcriptButton,
  verticalMargin = 'none',
  ...thumbnailProps
}) {
  const [lightBoxIsOpen, setLightBoxIsOpen] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(VideoSection, {
    dataCy: "video-thumbnail",
    _name: _name,
    id: id,
    padding: "large",
    textAlign: "center",
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(_thumbnail.default, (0, _extends2.default)({}, thumbnailProps, {
    onClick: () => setLightBoxIsOpen(true)
  })), /*#__PURE__*/_react.default.createElement(_videoLightbox.default, {
    youTubeId: youTubeId,
    showModal: lightBoxIsOpen,
    handleClose: () => setLightBoxIsOpen(false),
    transcriptButton: transcriptButton,
    ariaLabelCloseButton: ariaLabelCloseButton
  }));
}
VideoThumbnail.propTypes = {
  _name: _propTypes.default.string,
  id: _propTypes.default.string,
  youTubeId: _propTypes.default.string,
  ariaLabelCloseButton: _propTypes.default.string,
  transcriptButton: _propTypes.default.shape(_merchButton.NSMerchButton.propTypes),
  ..._thumbnail.default.propTypes,
  ..._patternLibraryUtils.marginProps
};